<script lang="ts">
import type { DailySpinProgress } from '@/types'
import { type PropType, defineComponent } from 'vue'

import WeeklyProgress from '../common/WeeklyProgress.vue'

/**
 * DailyGameCard
 */
export default defineComponent({
  components: {
    WeeklyProgress,
  },
  props: {
    progress: {
      type: Object as PropType<DailySpinProgress[]>,
      required: true,
    },
  },
  methods: {
    async redirectToDailySpins() {
      await this.$router.push({ name: 'daily-spins' })
    },
  },
})
</script>

<template>
  <div class="flex flex-col gap-2 rounded-lg p-3 border border-[#B6C6CF]">
    <p class="flex gap-2 font-semibold">
      <AppIcon :icon="Icons.CalendarStar" /> Spin & Win Daily Game
    </p>

    <WeeklyProgress class="my-1" :progress />

    <AppRegisterSignInModal id="daily-game-signup-signin-modal">
      <template v-if="$userStore.isLoggedOut" #button="{ openModal }">
        <AppButton
          class="button-thin !max-w-full bg-primary !py-2 text-sm leading-4"
          title="Play For Free"
          @click="openModal('register', redirectToDailySpins)"
        >
          Play For Free
        </AppButton>
      </template>
    </AppRegisterSignInModal>

    <AppButton
      v-if="$userStore.isLoggedIn"
      class="button-thin !max-w-full bg-primary !py-2 text-sm leading-4"
      title="Play For Free"
      :route="{ name: 'daily-spins' }"
    >
      Play For Free
    </AppButton>
  </div>
</template>
